var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareAgency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -839.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Agency",
    transform: "translate(3498.000000, 839.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.718984272,10.000275 C6.39686007,10.000275 10.9997594,14.6032175 10.9997594,20.2801465 L10.9997594,20.2801465 L10.9997594,20.4991438 L20.9995406,20.4991438 L20.9995406,20.2801465 C20.9995406,14.6032175 25.60144,10.000275 31.2793158,10.000275 L31.2793158,10.000275 L31.9993,10.000275 L31.9993,22.4991188 L10.9997594,22.4991188 L10.9997594,32 L-4.54747351e-13,32 L-4.54747351e-13,10.000275 Z M32,24.4990938 L32,28.4990438 L20.9992406,28.4990438 L20.9992406,24.4990938 L32,24.4990938 Z M7.32863969,-9.59232693e-14 C9.54759115,-9.59232693e-14 11.3465518,1.79897751 11.3465518,4.01794978 C11.3465518,6.23792203 9.54759115,8.03689954 7.32863969,8.03689954 C5.1106882,8.03689954 3.31072758,6.23792203 3.31072758,4.01794978 C3.31072758,1.79897751 5.1106882,-9.59232693e-14 7.32863969,-9.59232693e-14 Z M26.1261285,-9.59232693e-14 C28.34508,-9.59232693e-14 30.1440406,1.79897751 30.1440406,4.01794978 C30.1440406,6.23792203 28.34508,8.03689954 26.1261285,8.03689954 C23.907177,8.03689954 22.1082164,6.23792203 22.1082164,4.01794978 C22.1082164,1.79897751 23.907177,-9.59232693e-14 26.1261285,-9.59232693e-14 Z",
    id: 119
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareAgency);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-agency.9a3ca851.svg";
export { ForwardRef as ReactComponent };